import party from 'party-js';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useAlgo } from '../hooks/useAlgo';
import Button from './Button';
import Spinner from './Spinner';

const KittyModalEdit = ({ kitty, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState();
  const [error, setError] = useState();
  const { updateBio } = useAlgo();
  const confettiRef = useRef();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      name: kitty?.bio?.bio?.name || '',
      quote: kitty?.bio?.bio?.quote || '',
    },
  });

  const submit = async (data) => {
    setLoading(true);
    setError(null);
    setSuccess();

    const { name, quote } = data;

    if (quote.length > 60) {
      setError('Quote must be less than 60 characters.');
      setLoading(false);
      return;
    }

    try {
      await updateBio({ name, quote, kitty });
      setSuccess(true);
      party.confetti(confettiRef.current, {
        count: party.variation.range(20, 60),
      });
      party.confetti(confettiRef.current, {
        count: party.variation.range(20, 60),
      });
      party.confetti(confettiRef.current, {
        count: party.variation.range(20, 60),
      });
      onSuccess();
    } catch (error) {
      setError(error?.response?.data || 'Unexpected error');
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setValue('name', kitty?.bio?.bio?.name || '');
    setValue('quote', kitty?.bio?.bio?.quote || '');
  }, [kitty?.bio]);

  return (
    <form className='mt-4 space-y-5 max-w-xs' onSubmit={handleSubmit(submit)}>
      <div>
        <label htmlFor='address' className='mb-1 text-lg font-medium text-neutral-300'>
          Kitty's Name
        </label>
        <input
          id='name'
          type='text'
          required
          {...register('name', { required: false })}
          className='block w-full mt-1 border-transparent rounded-md shadow-sm bg-neutral-800 text-neutral-200 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50'
        />
      </div>
      <div>
        <label htmlFor='address' className='mb-1 text-lg font-medium text-neutral-300'>
          Quote
        </label>

        <input
          id='quote'
          type='text'
          {...register('quote', { required: false })}
          className='block w-full mt-1 border-transparent rounded-md shadow-sm bg-neutral-800 text-neutral-200 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50'
        />
      </div>
      {error && (
        <div className='text-red-500'>
          <p>{error}</p>
        </div>
      )}

      <Button type='submit'>{loading ? <Spinner dimensionClasses='w-6 h-6' /> : success ? 'Successfully updated! ✅' : 'Update bio'}</Button>
      <div ref={confettiRef}></div>
      <div className='text-neutral-500'>
        <p className='text-sm'>This will send an opt-in transaction with the updates to the kitty's bio in the note field.</p>
      </div>
    </form>
  );
};

export default KittyModalEdit;
